import { DetailValue, Image } from 'components/common'
import { getDetailUrl } from 'models/Tenant/api'


const TenantValue = ({ detail, asLink, isBack }) => {
  return (
    <DetailValue
      url={asLink && getDetailUrl(detail)}
      isBack={isBack}
      className="flex"
      render={() => (
        <>
          <Image src={detail?.icon[0]?.url} width={80} height={60} />
          {detail?.name || '-'}
        </>
      )}
    />
  );
};


export default TenantValue
